export const defaultErrorText = 'Something went wrong while loading the popup content.';
